import moment from "moment";

import { type IBaseEntity } from "types/apiResponse/apiResponse";

import { type IListRowData, ListEntity } from "utilities/list/list.types";

import {
    BuilderEntry,
    ExportHeader,
    JobEntry,
} from "entity/schedule/Calendar/CalendarList/CalendarList.api.types";

export type WorkdayExceptionListFormActions =
    | "newWorkdayException"
    | "checkedAction"
    | "download"
    | undefined;

export class WorkdayExceptionListResponse {
    constructor(data: any) {
        this.data = data;
    }
    data: any;
}

export class WorkdayExceptionListEntity extends ListEntity {
    constructor(response: WorkdayExceptionListResponse) {
        super(response.data);
        this.workdayExceptions = response.data.data.map((li: any) => new WorkdayExceptionEntry(li));
        this.isCalendarOffline = response.data.isCalendarOffline;
        this.isBaselineSet = response.data.isBaselineSet;
        this.canSetBaseline = response.data.canSetBaseline;
        this.jobs = response.data.jobs.map((j: any) => new JobEntry(j));
        this.builders = response.data.builders.map((b: any) => new BuilderEntry(b));
        this.exportHeader = response.data.exportHeader
            ? new ExportHeader(response.data.exportHeader)
            : undefined;
    }
    workdayExceptions: WorkdayExceptionEntry[];
    isCalendarOffline: boolean;
    isBaselineSet: boolean;
    canSetBaseline: boolean;
    jobs: JobEntry[];
    builders: BuilderEntry[];
    exportHeader?: ExportHeader;
}

export class WorkdayExceptionEntry implements IBaseEntity, IListRowData {
    constructor(data: any) {
        this.id = data.id;
        this.title = data.title;
        this.startDate = moment(data.startDate);
        this.endDate = moment(data.endDate);
        this.duration = data.days;
        this.type = data.workdayExceptionType ? "Extra workday" : "Non-workday";
        this.isNonWorkday = !data.nonWorkday;
        this.category = data.category;
        this.recurrence = data.sameEveryYear ? "Yearly" : "One time";
        this.notes = data.notes;
        this.jobs = data.jobs ? JSON.parse(data.jobs).map((job: any) => new JobInfo(job)) : [];
        this.allJobs = this.jobs.length === 0;
        this.builderName = data.builderName;
        this.rowAction = data.rowAction;
    }

    // IBaseEntity
    id: number;
    jobId: number;
    builderId: number;

    // Workday Exception
    title: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
    duration: number;
    type: string;
    category: string;
    recurrence: string;
    allJobs: boolean;
    notes: string;
    jobs: JobInfo[];
    isNonWorkday: boolean;
    builderName: string;
    rowAction: IWorkdayExceptionRowAction;
}

interface IWorkdayExceptionRowAction {
    id: number; // This is the WDE ID
    builderId: number;
}

export class JobInfo {
    constructor(data: any) {
        this.id = data.jobId;
        this.name = data.jobName;
    }
    id: number;
    name: string;
}
